import Beranda from "../../../../../components/categories/operational/qr_patrol/beranda/Home";
export default function Home() {
  
  return (
    <Beranda />
  );
}
